module.exports = __webpack_public_path__ + "static/b2-b13455350968aa523adad64d27936806.jpg";